{
    "Profile_BoundPolicyNotice.header": "Bound policy: limited editing",
    "Profile_BoundPolicyNotice.body": "This policy is bound. As an administrator you can correct its details, but the selected quote cannot change.",
    "Profile_BoundPolicyNotice.locked": "Locked: {fields}.",
    "Profile_BoundPolicyNotice.documents": "After a change, regenerate the affected documents from the Documents tab.",
    "Profile_BoundPolicyNotice.field.riskAddress": "property address",
    "Profile_BoundPolicyNotice.field.saleAmount": "sale price",
    "Profile_BoundPolicyNotice.field.propertySaleStatus": "sale status",
    "Profile_BoundPolicyNotice.field.unknown": "{code}"
}
